import { LOGIN_ACCOUNT_NAME } from './../app.constant';
import { ApiResponse } from './../models/ApiResponse';
import { AUTHENTICATED_USER, TOKEN, API_URL, MAIN_ACCOUNT_ID } from "../app.constant";

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Account } from "../models/account";

import { map } from "rxjs/operators";

import { BehaviorSubject } from "rxjs";

@Injectable()
export class BasicAuthenticationService {
  public isUserBanned: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(private router: Router, private http: HttpClient) {}

  executeObsAuthenticationService(username, password) {
    return this.http
      .get<any>(
        `${API_URL}/COM_GetLogInResult?accountId=${username}&password=${password}`
      )
      .pipe(
        map(response => {
          
          var firstKey = Object.keys(response)[0];

          let account: Account;

          if (firstKey.toUpperCase() == "OK") {
            account = response[firstKey];

            let today = new Date();

            let banExipryDate = new Date(account.banExpiryDate);

            if (banExipryDate > today) {
              this.isUserBanned.next(true);
            } else {
              this.isUserBanned.next(false);
            }

            var secondKey = Object.keys(response)[1];

            if(secondKey.toUpperCase() == "TOKEN"){
              sessionStorage.setItem(TOKEN, response.TOKEN);
            }
          } else if (firstKey.toUpperCase() == "ERROR") {



          }

          return response;
        })
      );
  }

  getAuthenticatedUser() {
    return sessionStorage.getItem(AUTHENTICATED_USER);
  }

  getMainAccountId() {
    return sessionStorage.getItem(MAIN_ACCOUNT_ID);
  }

  getLoginAccountName() {
    return sessionStorage.getItem(LOGIN_ACCOUNT_NAME);
  }

  isUserLoggedIn() {
    let user = sessionStorage.getItem(AUTHENTICATED_USER);
    return !(user === null);
  }

  logout() {
    this.clearSession();
    this.router.navigate(["/login"]);
  }

  clearSession() {
    sessionStorage.clear();
  }
}

export class AuthenticationBean {
  constructor(public message: string) {}
}
